/**
 * @fileoverview gRPC-Web generated client stub for resellers
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.resellers = require('./resellers_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.resellers.ResellersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.resellers.ResellersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.resellers.ResellersRequest,
 *   !proto.resellers.ResellersResponse>}
 */
const methodDescriptor_Resellers_GetResellers = new grpc.web.MethodDescriptor(
  '/resellers.Resellers/GetResellers',
  grpc.web.MethodType.UNARY,
  proto.resellers.ResellersRequest,
  proto.resellers.ResellersResponse,
  /**
   * @param {!proto.resellers.ResellersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.resellers.ResellersResponse.deserializeBinary
);


/**
 * @param {!proto.resellers.ResellersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.resellers.ResellersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.resellers.ResellersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.resellers.ResellersClient.prototype.getResellers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/resellers.Resellers/GetResellers',
      request,
      metadata || {},
      methodDescriptor_Resellers_GetResellers,
      callback);
};


/**
 * @param {!proto.resellers.ResellersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.resellers.ResellersResponse>}
 *     Promise that resolves to the response
 */
proto.resellers.ResellersPromiseClient.prototype.getResellers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/resellers.Resellers/GetResellers',
      request,
      metadata || {},
      methodDescriptor_Resellers_GetResellers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.resellers.ResellerRequest,
 *   !proto.resellers.ResellersResponse>}
 */
const methodDescriptor_Resellers_EditResellerName = new grpc.web.MethodDescriptor(
  '/resellers.Resellers/EditResellerName',
  grpc.web.MethodType.UNARY,
  proto.resellers.ResellerRequest,
  proto.resellers.ResellersResponse,
  /**
   * @param {!proto.resellers.ResellerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.resellers.ResellersResponse.deserializeBinary
);


/**
 * @param {!proto.resellers.ResellerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.resellers.ResellersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.resellers.ResellersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.resellers.ResellersClient.prototype.editResellerName =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/resellers.Resellers/EditResellerName',
      request,
      metadata || {},
      methodDescriptor_Resellers_EditResellerName,
      callback);
};


/**
 * @param {!proto.resellers.ResellerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.resellers.ResellersResponse>}
 *     Promise that resolves to the response
 */
proto.resellers.ResellersPromiseClient.prototype.editResellerName =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/resellers.Resellers/EditResellerName',
      request,
      metadata || {},
      methodDescriptor_Resellers_EditResellerName);
};


module.exports = proto.resellers;

